module.exports = __webpack_public_path__ + "img/search-icon.bad8f894.svg";